<template>
  <b-container fluid>
    <div class="card">
      <div class="card-body">
        <h4 class="mb-4">
          <strong>Filtros de Busca</strong>
        </h4>
        <a-form layout="vertical">
          

          <div class="row">

            <div class="col-xl" v-if="sysNonMerchantUser">
              <a-form-item label="Merchant:">
                <v-select
                  label="name"
                  :filterable="false"
                  :options="merchants"
                  :reduce="(merchant) => merchant.id"
                  v-model="filtrosLocal.idMerchant"
                  @search="onSearch"
                >
                  <template slot="no-options"
                    >Pesquisar Estabelecimento</template
                  >
                  <template slot="option" slot-scope="option">{{
                    option.name
                  }}</template>
                  <template slot="selected-option" slot-scope="option">{{
                    option.name
                  }}</template>
                </v-select>
              </a-form-item>
            </div>

            <div v-if="sysAdminUser" class="col-md-4">
              <a-form-item label="Canal de Venda">
                <a-select
                  default-value="0"
                  v-model="filtrosLocal.idSalechannel"
                >
                  <a-select-option value="0"> Selecione </a-select-option>
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in salechannels"
                    :key="`adquirente-${index}`"
                  >
                    {{ item.description }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <b-button class="col-12" @click="limparFiltros">Limpar</b-button>
            </div>
            <div class="col-md-2">
              <b-button
                class="col-12"
                @click="filtrar"
                variant="outline-primary"
                >Filtrar</b-button
              >
            </div>
          </div>
        </a-form>
      </div>
    </div>
    <template v-if="loading">
      <div class="d-flex justify-content-center bd-highlight mb-3">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="card">
        <div class="card-body">
          <!-- Main table element -->
          <a-table
            show-empty
            stacked="md"
            :columns="fields"
            rowKey="idMerchant"
            :dataSource="displayItens"
            :per-page="perPage"
            v-on:expand="handleExpandedChanged"

          >
            <template slot="dtUpdated" slot-scope="row">
              {{ moment(row).format("DD/MM/YYYY") }}</template
            >

         <template slot="fgContractSigned" slot-scope="row">
          <span class="font-size-24"
            ><i
              :class="[
                row === true
                  ? 'ml-1 fa-3 text-primary fa fa-toggle-on'
                  : 'ml-1 fa-3 text-default fa fa-toggle-off',
              ]"
              class=""
              aria-hidden="true"
            ></i>
          </span>
        </template> 

        <template slot="approved" slot-scope="text">
          <b-button variant="primary" @click="approvedEvent(text)"> Aprovar  </b-button>

        </template>

      <!--   <p slot="expandedRowRender" slot-scope="record" style="margin: 0">{{record.idMerchant}}</p> -->

         <a-table
               
                slot="expandedRowRender"
                slot-scope="record"
                :columns="merchantFileColumns"
                :rowKey="record.idMerchant.toString()"
                :dataSource="getMerchantFiles[record.idMerchant]"
                 :loading="getLoadMerchantFiles"
                 :pagination="false"
              >
               

                <span slot="merchantFileType" slot-scope="text">
                  {{ text }}</span
                >


              
            <b-button slot="name" slot-scope="text"
              size="sm"
              target="_blank"
              :href="`${text.includes('http') ? '' : onboardFilesCnd }${text}`"
              ><i class="fe fe-eye"></i
            ></b-button>
         
               
              </a-table> 

          </a-table>
        </div>
      </div>
    </template>
   
    <!-- <b-modal ref="editar" hide-footer title="Editar Merchant" size="xl">
      <template v-slot:default="{ hide }">
        <formulario-equipamentos @hide="hide" :edicao="true" :dispositivo="dispositivoEditar" />
      </template>
    </b-modal> -->
  </b-container>
</template>

<script>
import { get as _get, debounce as _debounce } from "lodash";
import { MerchantContractResource } from "@/resources/MerchantContract.resource.js";
import { Contants } from "@/utils/constants.js";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";


export default {
  name: "ListMerchantReviewContract",
  
  data() {
    return {
      loading: false,
       loadingFiles: false,
      filtrosLocal: {
        index: 1,
        size: 50,
        idMerchant: null,
        idSaleChannel: null,
      },
      itens: [],
      onboardFilesCnd: Contants.OnboardingFilesUrl,
      displayItens: [],
      itensFiles: [],
      displayItensFiles: [],
       
      merchants: [],
      salechannels: [],

     merchantFileColumns : [
  {
    title: "Tipo de Arquivo",
    dataIndex: "merchantFileType",
    key: "merchantFileType",
    scopedSlots: { customRender: "merchantFileType" },
  },

  {
    title: "Nome",
    dataIndex: "name",
    key: "name",
    scopedSlots: { customRender: "name" },
  },

  

  
],

      fields: [
        {
    title: "#",
    dataIndex: "idMerchant",
    key: "idMerchant",
    // scopedSlots: { customRender: "transactionStatus" },
     },
       
        {
          dataIndex: "merchantName",
          key: "merchantName",
          title: "Nome",
        },

        {
          key: "document",
          dataIndex: "document",
          title: "Documento",
        },

        {
          key: "dtUpdated",
          dataIndex: "dtUpdated",
          title: "Ultima Atualização",
           scopedSlots: { customRender: "dtUpdated" },
        },

        {
          key: "status",
          dataIndex: "status",
          title: "Status",
        },

        {
          key: "saleChannel",
          dataIndex: "saleChannel",
          title: "Canal de Venda",
        
        },

        {
          key: "fgContractSigned",
          title: "Contrato Assinado",
          dataIndex: "fgContractSigned",
          scopedSlots: { customRender: "fgContractSigned" },
          
        },

        {
          key: "approved",
          dataIndex: "IdMerchant",
          title: "Aprovar?",
          scopedSlots: { customRender: "approved" },
          
        },
        

        //{key :"edit", label: "Ver"},
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100, 150],
      sortBy: "idInvoice",
      sortDesc: true,
      sortDirection: "desc",
      filter: null,

      dateFormat: "DD/MM/YYYY",
      monthFormat: "YYYY/MM",
      dateFormatList: ["DD/MM/YYYY", "DD/MM/YY"],
    };
  },
  
  methods: {
    moment,
   
   approvedEvent(idMerchant){
      console.log(idMerchant);
   },
    handleCalendarChange(dates) {
      this.filtrosLocal.rangeDates = dates;
    },
    ...mapActions({
      merchantFiles: "merchantFiles"
    }),

    handleExpandedChanged(expanded,record){
     //  this.loadingFiles = true;
      if(!expanded) return;

    //   console.log("handleExpandedChanged");

      this.merchantFiles({payload: record.idMerchant});
     
            
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    search: _debounce((loading, search, vm) => {
      vm.$api
        .get("v1/merchant/keyvalue", {
          params: {
            name: search,
          },
        })
        .then((result) => {
          loading(false);
          vm.merchants = result.data.payload.map((item) => ({
            id: item.id,
            name: item.description,
          }));
        })
        .catch((e) => {
          // Surpress
        });
    }, 350),



    // lista de todos os dispositivos cadastrados
    getLista() {
      

      if (typeof this.itens[this.filtrosLocal.index] === "undefined") {
        // nessa situacao, precisamos buscar os dados, pois ainda nao forma consultados...
        this.loading = true;

        var filtros = { ...this.filtrosLocal };
        filtros.idMerchant = this.sysNonMerchantUser
          ? filtros.idMerchant
          : null;
        filtros.idMerchant =
          filtros.idMerchant == 0 ? null : filtros.idMerchant;

        MerchantContractResource.getListPendingReview(filtros)
          .then((result) => {
            try {
              this.itens[this.filtrosLocal.index] = result.data.payload.items;
              this.displayItens = this.itens[this.filtrosLocal.index].flat();
              this.totalRows = result.data.payload.pageSettings.total;
              this.loading = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason:
                      "Erro ao solicitar os dados, por favor tente novamente",
                  },
                },
              };
            }
          })
          .catch((e) => {
            // Surpress
            this.loading = false;
          });
      } else {
        // se já temos, apenas movesmo para a lista de exibicao...
        this.displayItens = this.itens[this.filtrosLocal.index].flat();
      }
    },

  

    onChangePage(a) {
      // uma mudanca do page filter ocorreu, vamos atualizar a lista...
      this.filtrosLocal.index = a;
      this.getLista();
    },
    editarItem(item) {
      this.dispositivoEditar = item;
      this.$refs["editar"].show();
    },
    limparFiltros() {
      this.filtrosLocal = {
        index: 1,
        size: 50,
        idMerchant: 0,
        idStatus: 0,
       
      };
      this.filtrar();
    },
    filtrar() {
      // se algum item do filtro for 0, mudar para null
      this.itens = [];
      this.displayItens = [];
      this.currentPage = 1;
      this.getLista();
    },
  },
  computed: {
     ...mapGetters([
      "getMerchantFiles",
      "getLoadMerchantFiles"
    ]) ,
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  

    sysAdminUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter((role) => role === "SystemAdmin").length > 0
        );
      } catch (e) {
        return false;
      }
    },

    sysNonMerchantUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter((role) => role !== "Merchant-Manager").length > 0
        );
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {
    this.filtrar();
  },
  created() {
  
   // this.getCostCenter();
  },
};
</script>
